// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Container,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CardSkeleton from '../MarketingSiteComponents/CardSkeleton';
import getMedineerTestPackages from '../services/getMedineerTestPackages';
import cardTemplateDescriptionsData from '../staticDataTemplate.json';
import demoCardTemplateDescriptions from '../staticDataTemplateDemoServer.json';

export const TestPackages = ({ openTwoCardModal, setOpenTwoCardModal, subscription }) => {
    const navigate = useNavigate();
    const isProduction = window.location.origin === "https://www.medineer.ai" || window.location.origin === "https://medineer.ai" ? true : false;
    const cardTemplateDescriptions = isProduction ? cardTemplateDescriptionsData : demoCardTemplateDescriptions
    const hasFetchedRef = useRef(false);
    const [testSeries, setTestSeries] = useState([]);

    const [loading, setLoading] = useState(false);
    const pageSize = 4;
    // const fetch = async () => {
    //     try {
    //         let ids;
    //         // if (contentCuratorIds.length <= 0) {
    //         const data = await getProviderContentCuratorIds(configUrl.MediNeerProviderId);
    //         ids = data?.$values || [];
    //         // }
    //         axios.defaults.headers.common = {
    //             providerId: configUrl.MediNeerProviderId,
    //             contentProviderIds: ids // ?? contentCuratorIds
    //         };
    //         // console.log('gettinghere2', ids, 'xx', contentCuratorIds)
    //         // setContentCuratorIds(ids ?? contentCuratorIds);
    //     } catch (error) {
    //         console.log("error getting contentcuratorids");
    //     }
    // };
    const handleOfferModal = () => {
        setOpenTwoCardModal(true)
    }
    const fetchTests = async (page = 1) => {
        setLoading(true);

        try {
            const specificCourseIdsArray = cardTemplateDescriptions?.Cards
                ?.filter(card => card.isPackage && card.Type == "TestSeries")
                ?.map(card => card.ID);

            const specificCourseIds =
                specificCourseIdsArray?.length > 0
                    ? specificCourseIdsArray.join(',')
                    : null;

            const fetchedTests = await getMedineerTestPackages({
                pageNumber: page,
                pageSize,
                specificCourseIds,
            });

            setTestSeries(fetchedTests);

            // if (fetchedTests.length > 0) {
            //     setOpenTwoCardModal(true);
            // }
        } catch (error) {
            console.error('Error fetching test series:', error);
        } finally {
            setLoading(false);
        }
    };


    const onEnroll = (seriesProp) => {
        console.log("series-", seriesProp, "assignLicnesescountssecond", (seriesProp?.assingnedStudentsCount + 1) > seriesProp?.testSeriesStudentsCount);
        // if (series?.assingnedStudentsCount && series?.testSeriesStudentsCount && series?.testSeriesStudentsCount > 0 && (series?.assingnedStudentsCount + 1) > series?.testSeriesStudentsCount) {
        //     message.error("Please contact the admin.");
        // } else {
        let ResourceTypeId = seriesProp?.ResourceTypeId ? seriesProp?.ResourceTypeId : 3;
        let series = seriesProp;
        navigate('/medineer/SignUp', { state: { series, ResourceTypeId } });
        // }
    }
    useEffect(() => {
        if (hasFetchedRef.current) return;

        hasFetchedRef.current = true;
        // setOpenTwoCardModal(true);
        fetchTests(1);
    }, []);

    const bestCoupen = (course) => {
        const availableCoupons = course?.coupons?.$values || [];
        const bestCoupon = availableCoupons?.length
            ? availableCoupons.reduce((prev, curr) =>
                (curr?.discountPercentage || 0) > (prev?.discountPercentage || 0) ? curr : prev
            )
            : null;
        return bestCoupon;
    }
    const renderPackageCard = (pkg, index, isModal = false) => {
        const cardData = cardTemplateDescriptions?.Cards?.find(
            card => (card.ID === pkg.cardId && card.isPackage === true && (pkg?.type == "Subscription" ? card.Type == "Subscription" : true))
        );
        console.log("datacard", cardData, "  ", isModal == true)
        const cardDescription = cardData
            ? cardData.CardBulletPoints
            : cardTemplateDescriptions.Cards[0]?.CardBulletPoints || ["No details available"];
        console.log(cardData, '- cardData', pkg, '-pkgs')
        console.log(bestCoupen(pkg), '-kkklll')
        return (
            <Grid item xs={12} sm={6} lg={isModal ? 6 : 3} key={index}>
                <Card
                    sx={{
                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        textAlign: "left",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        transition: "all 0.3s ease",
                        border: cardData?.popular ? 1.5 : 1,
                        borderRadius: '1.75rem',
                        borderColor: cardData?.popular ? "#FF9310" : "#d1d9e0",
                        transform: cardData?.popular ? "scale(1.05)" : "scale(1)",
                        "&:hover": {
                            transform: cardData?.popular ? "scale(1.04)" : "scale(1.02)",
                            boxShadow: 6,
                        },
                    }}
                >
                    {cardData?.popular && (
                        <Chip
                            label="Most Popular"
                            // color="secondary"
                            sx={{
                                background: 'linear-gradient(90deg,rgba(255, 147, 16, 1) 44%, rgba(255, 147, 16, 1) 24%, rgba(255, 125, 44, 1) 80%)',
                                color: '#fff',
                                fontSize: '1rem',
                                height: '20px',
                                position: "absolute",
                                top: -2,
                                left: "50%",
                                transform: "translateX(-50%)",
                                fontWeight: 700,
                                boxShadow: 2,
                            }}
                        />
                    )}

                    <CardContent sx={{ p: 3, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, fontSize: '2rem', color: '#0f1a24', textAlign: "center", }}>
                            {/* {cardData.title} */}
                            {pkg.text}
                        </Typography>
                        {/* Pkg Subtitle section */}
                        {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: '1.4rem', lineHeight: '2rem', color: '#52667a' }}>
                                                {pkg.subtitle}
                                            </Typography> */}
                        <Box style={{ width: "fit-content", mb: 2, px: 2, py: 1, alignSelf: 'center' }}>
                            {/* <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}> */}
                            <Chip label={cardData?.TagOnCard} color="primary" size="small"
                                sx={{
                                    mb: 0.5,
                                    fontWeight: 600,
                                    bgcolor: '#fff',
                                    color: '#00264d',
                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    border: '1px solid #00264d',
                                    // px: '0.75rem',
                                    fontSize: '1.2rem'
                                }}
                            />
                        </Box>
                        <Box >
                            {/* <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1.4rem', lineHeight: '2rem', color: '#52667a' }}>
                                                    <strong>Target:</strong>
                                                    {cardData?.targetYear}
                                                </Typography> */}
                            <Typography variant="body2" sx={{ color: '#0b3054', textAlign: 'center', fontSize: '1.4rem', fontWeight: '700', lineHeight: '2rem' }}>
                                {/* <strong>Total Tests:</strong>  */}
                                {cardData?.SubjectTagOnCard}
                            </Typography>
                            {/* <Chip label="Online" size="small" sx={{ mt: 1 }} /> */}
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, justifyContent: 'center', }}>
                                {/* <Box
                                sx={{
                                    px: 1.2,
                                    py: 0.3,
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    borderRadius: '50% 5% 50% 5%',
                                    color: '#0B3054',
                                    background: 'linear-gradient(90deg, #ffa100, #ffd100)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    boxShadow: '0 2px 8px rgba(255,81,47,0.35)',
                                    animation: 'pulseBadge 1.6s ease-in-out infinite',

                                    '@keyframes pulseBadge': {
                                        '0%, 100%': { transform: 'scale(1)' },
                                        '50%': { transform: 'scale(1.05)' },
                                    },
                                }}
                            >
                                {Math.round(
                                    ((cardData?.originalPrice - pkg.price) / cardData?.originalPrice) * 100
                                )}
                                %
                            </Box> */}
                                {bestCoupen(pkg)?.discountPercentage > 0 && <Box
                                    sx={{
                                        width: 70,
                                        height: 70,
                                        backgroundImage: `url(/offersicon.PNG)`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "1.2rem",
                                        fontWeight: 800,
                                        color: "#0B3054",
                                        textShadow: "0 1px 2px rgba(0,0,0,0.2)",
                                        animation: "pulseBadge 1.6s ease-in-out infinite",

                                        "@keyframes pulseBadge": {
                                            "0%, 100%": { transform: "scale(1)" },
                                            "50%": { transform: "scale(1.08)" },
                                        },
                                    }}
                                >
                                    {/* {Math.round(
                                            ((cardData?.originalPrice - pkg.price) /
                                                cardData?.originalPrice) *
                                            100
                                        )} */}
                                    <Box sx={{ fontSize: "1.3rem", lineHeight: '1.2rem' }}>
                                        {bestCoupen(pkg)?.discountPercentage}
                                        % </Box>
                                    <small style={{ fontWeight: '400' }}>OFF</small>
                                </Box>}
                                <Typography variant="h4" color="#0f1a24" sx={{ color: '#ff9310', fontWeight: 700, fontSize: '3rem', lineHeight: '3.6rem', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                                    {/* ₹{pkg.discountedPrice} */}
                                    {/* ₹{pkg.price} */}
                                    {bestCoupen(pkg)?.discountPercentage > 0 ?
                                        (`₹${pkg.price - (pkg.price * bestCoupen(pkg)?.discountPercentage) / 100}`)
                                        : (`₹${pkg.price}`)
                                    }
                                </Typography>
                                {bestCoupen(pkg)?.discountPercentage > 0 && <Typography
                                    variant="h6"
                                    sx={{ textDecoration: "line-through", fontWeight: '400', fontSize: '1.8rem', lineHeight: '2.8rem', color: '#52667a', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}
                                >
                                    ₹{pkg.price}
                                </Typography>}
                            </Box>
                            {/* <Typography variant="body2" color="secondary" sx={{ fontWeight: 600, mt: 0.5, fontSize: '1.4rem', lineHeight: '2rem', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                                                Save{" "}
                                                {Math.round(
                                                    ((cardData?.originalPrice - pkg.discountedPrice) / cardData?.originalPrice) * 100
                                                )}
                                                %
                                            </Typography> */}
                        </Box>

                        <List dense sx={{ mb: 3, flexGrow: 1 }}>
                            {cardDescription.map((feature, idx) => (
                                <ListItem key={idx} disableGutters>
                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                        <CheckOutlinedIcon sx={{ fontSize: 20, color: "secondary.main" }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={feature}
                                        primaryTypographyProps={{ variant: "body2", color: "#52667a", fontSize: '1.4rem', lineHeight: '1.3rem', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                            <Button
                                variant="contained"
                                // color={cardData?.popular ? "#FFA100" : "#012950"}
                                fullWidth
                                onClick={() => onEnroll(pkg)}   // window.location.href = pkg.buyNowUrl;   
                                sx={{
                                    background: cardData?.popular ? "#FFA100" : "#0B3054",
                                    color: cardData?.popular ? "#0B3054" : "#fff",
                                    fontSize: "1.4rem",
                                    lineHeight: "2rem",
                                    fontWeight: 600,
                                    borderRadius: "0.85rem",
                                    textTransform: "none",
                                    py: '1.1rem',
                                    px: '0.5rem',

                                }}
                            >
                                Buy Now
                            </Button>
                            {/* {pkg.plannerUrl && (
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                startIcon={<FileDownloadOutlinedIcon />}
                                                fullWidth
                                                sx={{
                                                    color: "#0B3054",
                                                    fontSize: "1.4rem",
                                                    textTransform: "none",
                                                    py: '0.6rem',
                                                    px: '0.5rem',
                                                    borderRadius: "0.85rem",
                                                    border: 'solid 2px #0B3054',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                Download Planner
                                            </Button>
                                        )} */}
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        )
    };

    const topicPulseCard = cardTemplateDescriptions?.Cards?.find(
        card => card.Type === "Subscription" && card.title === "Topic Pulse"
    );


    const packagesToRender = useMemo(() => {
        console.log("subscriptios is ", subscription)
        // ❗ Only show TopicPulse AFTER testSeries has loaded
        const showTopicPulse = !loading && testSeries && testSeries.length > 0;

        const topicPulsePackage =
            showTopicPulse && topicPulseCard && subscription
                ? {
                    id: subscription?.courseId,
                    courseId: subscription?.courseId,
                    ResourceTypeId: 4,
                    text: "Topic Pulse",
                    price: subscription?.price,
                    coupons: { $values: [] },
                    cardId: topicPulseCard.ID,
                    type: topicPulseCard.Type,
                    isTopicPulse: true
                }
                : null;

        const testSeriesPackages = (testSeries || []).map(t => ({
            ...t,
            ResourceTypeId: 3,
            cardId: t.courseId
        }));

        return [
            // ...(topicPulsePackage ? [topicPulsePackage] : []),
            ...testSeriesPackages
        ];

    }, [subscription, testSeries, loading]);
    console.log("package to render", packagesToRender)
    return (
        <Box sx={{ py: 10, bgcolor: "#EFF3F7" }}>
            <Container maxWidth="xl">
                <Box sx={{ textAlign: "center", mb: 8 }}>
                    <Chip label="Student's Choice" color="primary"
                        sx={{
                            mb: 2,
                            fontWeight: 600,
                            bgcolor: '#fff',
                            color: '#00264d',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            border: '1px solid #00264d',
                            px: '1rem',
                            fontSize: '1.2rem',


                        }}
                    />
                    <Typography variant="h2"
                        sx={{
                            mb: 2,
                            fontWeight: 700,
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '3.6rem',
                            lineHeight: '4rem',
                            color: '#0f1a24'

                        }}
                    >
                        Choose Your Test Series Package
                    </Typography>
                    <Typography variant="inherit"
                        sx={{
                            maxWidth: "800px", mx: "auto",
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '1.8rem',
                            lineHeight: '2.8rem',
                            color: '#52667a',
                            fontWeight: 400,
                        }}
                    >
                        Select the perfect plan that matches your preparation timeline and goals
                    </Typography>
                </Box>

                <Grid container spacing={3}>
                    {/* {cardTemplateDescriptions?.Cards?.filter(pkg => pkg.isPackage).map((pkg, index) => { */}
                    {packagesToRender && packagesToRender.length > 0 ?
                        packagesToRender
                            // Filter only those packages that have a matching course in static JSON AND isPackage = true
                            .filter(pkg =>
                                cardTemplateDescriptions?.Cards?.some(
                                    card => card.ID === pkg.cardId && card.isPackage === true
                                )
                            )
                            // Sort by cardData.packageSequence instead of pkg.packageSequence
                            .sort((a, b) => {
                                if (a.isTopicPulse) return -1;
                                if (b.isTopicPulse) return 1;

                                const cardA = cardTemplateDescriptions?.Cards?.find(card => card.ID === a.cardId);
                                const cardB = cardTemplateDescriptions?.Cards?.find(card => card.ID === b.cardId);

                                return (cardA?.packageSequence || 0) - (cardB?.packageSequence || 0);
                            })
                            .map((pkg, index) => renderPackageCard(pkg, index)
                            ) : (
                            <Box sx={{ flex: '0 0 auto', width: '100%', height: '300px', m: 1, justifyContent: 'center' }}>
                                {loading ? <CircularProgress /> : null}
                                <h4 style={{ marginTop: '70px', color: '#0B3054' }}>{loading ? 'Loading packages...' : 'No packages found'}</h4>
                            </Box>)
                    }
                </Grid>
                <Dialog
                    open={openTwoCardModal}
                    onClose={() => setOpenTwoCardModal(false)}
                    maxWidth={false}
                    // fullWidth
                    scroll="body"
                    PaperProps={{
                        sx: {
                            width: "fit-content",
                            // minWidth: '60%',
                            // minHeight: '81vh',
                            maxWidth: "none",
                            overflow: "visible",
                            // alignItems: "stretch",
                            borderRadius: "1.5rem",
                        }
                    }}
                >
                    <DialogTitle sx={{ fontWeight: 700, backgroundColor: '#0B3054', color: '#fff', fontFamily: 'Poppins', fontSize: '2.2rem', textAlign: 'center' }}>
                        🔥<span style={{ color: '#F1C40F' }}>Limited-Time Offer</span> - Just for You! <br />
                        <span style={{ color: 'lightgray', fontWeight: '100' }}>Choose your deal before it's gone!</span>
                        <Button
                            onClick={() => setOpenTwoCardModal(false)}
                            sx={{
                                minWidth: "auto",
                                color: "#fff",
                                float: 'right'
                            }}
                        >
                            <CloseIcon />
                        </Button>
                    </DialogTitle>

                    <DialogContent sx={{
                        overflow: "visible",
                        p: 3,
                        backgroundColor: '#EFF3F7'
                    }}>
                        {loading ? (
                            <Grid container spacing={3} justifyContent="center" textAlign={'center'}
                                sx={{
                                    width: "auto",
                                    margin: 0,
                                }}
                            >
                                {Array.from(new Array(2)).map((_, i) => (
                                    <CardSkeleton key={i} isModal={true} />
                                ))}
                            </Grid>
                        ) : packagesToRender && packagesToRender.length == 0 ? (
                            <Grid container spacing={3} justifyContent="center" textAlign={'center'}
                                sx={{
                                    width: "auto",
                                    margin: 0,
                                }}
                            >
                                <Grid item xs={12} sm={6} md={9}>
                                    <Typography color="text.secondary">
                                        No packages available
                                    </Typography>
                                </Grid>
                            </Grid>
                        ) :
                            (<Grid container spacing={3} justifyContent={'center'}
                                sx={{
                                    width: "auto",
                                    margin: 0,
                                }}
                            >
                                {packagesToRender
                                    ?.filter(pkg =>
                                        cardTemplateDescriptions?.Cards?.some(
                                            card =>
                                                card.ID === pkg.cardId &&
                                                card.isTrending === true
                                            // && card.isPackage === true
                                        )
                                    )
                                    .slice(0, 2).map((pkg, index) => renderPackageCard(pkg, index, true))}
                            </Grid>)}
                    </DialogContent>
                </Dialog>

                {/* <Button
                    variant="outlined"
                    sx={{ mb: 4 }}
                    onClick={() => setOpenTwoCardModal(true)}
                >
                    View Top 2 Packages
                </Button> */}

            </Container>
        </Box >
    );
};
